import FundSubscriberTransactions from './FundSubscriberTransactions';
import FundSubscriberTransactionDetails from './FundSubscriberTransactionDetails';
import FundDataUnitTransactions from './FundDataUnitTransactions';

const FundSubscriberTransactionsMain = {
  FundSubscriberTransactions,
  FundSubscriberTransactionDetails,
  FundDataUnitTransactions
};

export default FundSubscriberTransactionsMain;
